import { render, staticRenderFns } from "./lecturerWtxh.vue?vue&type=template&id=7b5bd524&scoped=true"
import script from "./lecturerWtxh.vue?vue&type=script&lang=js"
export * from "./lecturerWtxh.vue?vue&type=script&lang=js"
import style0 from "./lecturerWtxh.vue?vue&type=style&index=0&id=7b5bd524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5bd524",
  null
  
)

export default component.exports